import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';
import * as fromBaseSiteReducer from './site-context/reducers/site-context.reducer';
import * as fromCmsReducer from './cms/reducers/cms.reducer';
import * as fromCultureReducer from './cultures/reducers/cultures.reducer';
import * as fromProductReducer from './product/reducers/product.reducer';
import * as fromAlternates from './alternates/reducers/boels-alternates.reducers';
import * as fromProductSearchReducer from './product-search/reducers/product-search.reducer';
import * as fromGlobalProductSearchReducer from './global-product-search/reducers/global-product-search.reducer';
import * as fromCategories from './categories/reducers/categories.reducer';
import * as fromCatalogs from './catalog/reducers/catalogs.reducer';
import * as fromCart from './cart/reducers/cart.reducer';
import * as fromProductStock from './checkout/reducers/product-stock.reducer';
import * as fromGlobalMessage from './global-message/reducers/global-message.reducer';
import * as fromHolidays from './holidays/reducers/holidays.reducer';
import * as fromUserData from './user-data/reducers/user-data.reducer';
import * as fromStoreFinder from './store-finder/reducers/store-finder.reducer';

export interface BoelsState {
  cultures: fromCultureReducer.BoelsCultureState;
  baseSite: fromBaseSiteReducer.BaseSiteState;
  cmsState: fromCmsReducer.CmsPageState;
  userDataState: fromUserData.BoelsUserDataState;
  product: fromProductReducer.ProductState;
  alternatesState: fromAlternates.BoelsAlternatesState;
  productSearchState: fromProductSearchReducer.ProductSearchState;
  globalProductSearchState: fromGlobalProductSearchReducer.GlobalProductSearchState;
  categories: fromCategories.CategoriesState;
  catalogs: fromCatalogs.CatalogsState;
  cart: fromCart.CartState;
  productStock: fromProductStock.ProductStockState;
  globalMessages: fromGlobalMessage.GlobalMessageState;
  holidays: fromHolidays.HolidaysState;
  storeFinder: fromStoreFinder.StoreFinderState;
}

export const reducers: ActionReducerMap<BoelsState, any> = {
  cultures: fromCultureReducer.reducer,
  baseSite: fromBaseSiteReducer.reducer,
  cmsState: fromCmsReducer.reducer,
  product: fromProductReducer.reducer,
  alternatesState: fromAlternates.reducer,
  productSearchState: fromProductSearchReducer.reducer,
  globalProductSearchState: fromGlobalProductSearchReducer.reducer,
  categories: fromCategories.reducer,
  catalogs: fromCatalogs.reducer,
  cart: fromCart.cartReducerFunc,
  productStock: fromProductStock.reducer,
  globalMessages: fromGlobalMessage.reducer,
  holidays: fromHolidays.reducer,
  userDataState: fromUserData.userDataReducer,
  storeFinder: fromStoreFinder.reducer,
};

export const getStoreState = createFeatureSelector<BoelsState>('boelsState');
